import { Image, merge, TextField } from '@fluentui/react';
import React, { useCallback, useMemo, useState } from 'react';
import eyeIcon from '../assets/icons/svg/eye.svg';
import { ResponsiveSize, useResponsiveSize } from '../contexts/responsiveContext';

const FormField = (props) => {

    const {
        customStyles = {},
        disabled = false,
        hideInput = false,
        id = undefined,
        onChange = (event, newValue) => console.log({ ...event, newValue }),
        placeholder,
        prefixIcon,
        value = ""
    } = props;

    const { responsiveSize } = useResponsiveSize();

    const [type, setType] = useState(hideInput ? "password" : "text");

    const styles = useMemo(
        () => {
            let styles = {
                root: {
                    borderRadius: 0,
                    minHeight: 45,
                    width: 269,
                    selectors: {
                        "input:-webkit-autofill": {
                            "-webkit-box-shadow": `0 0 0 30px ${disabled ? "#f3f2f1" : "white"} inset !important` // Chrome : fond gris sur champs autofill
                        },
                    }
                },
                fieldGroup: {
                    boxShadow: "2px 2px 1px #C4C4C4",
                    border: "none",
                    borderRadius: 0,
                    height: 45,
                    width: "calc(100% - 2px)"
                },
                prefix: {
                    background: disabled ? "#f3f2f1" : "white",
                    paddingLeft: 16
                },
                prefixIcon: { image: { width: 20 } },
                suffix: {
                    background: disabled ? "#f3f2f1" : "white",
                    cursor: hideInput ? "pointer" : "unset"
                }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                merge(
                    styles,
                    { root: { width: "auto" } }
                );

            merge(styles, customStyles);

            return styles;
        },
        [customStyles, disabled, hideInput, responsiveSize]
    );

    const onClickSuffix = useCallback(() => setType(type === "password" ? "text" : "password"), [type]);

    const onRenderPrefix = useCallback(
        () => !!prefixIcon ? <Image src={prefixIcon} styles={styles.prefixIcon} /> : null,
        [prefixIcon, styles.prefixIcon]
    );

    const onRenderSuffix = useCallback(
        () => hideInput ? <Image src={eyeIcon} onClick={onClickSuffix} styles={styles.suffix} /> : null,
        [hideInput, onClickSuffix, styles.suffix]
    );

    return <TextField
        disabled={disabled}
        id={id}
        onChange={onChange}
        onRenderPrefix={onRenderPrefix}
        onRenderSuffix={onRenderSuffix}
        placeholder={placeholder}
        styles={styles}
        type={type}
        value={value}
    />;

};

export default FormField;